<template>
  <section class="mt-space-lg mt-lg-space-xxl mb-space-lg">
    <div class="container">
      <div class="row">
        <div class="offset-lg-2 col-12 col-lg-8">
          <div
            class="d-flex flex-column gap-space-md justify-content-center align-items-center"
          >
            <div class="bg-secondary quote-container rounded-circle">
              <FontAwesomeIcon icon="quotes" />
            </div>
            <div>
              <h2 class="text-center h2-medium" v-html="quoteText"></h2>
            </div>
            <div class="text-center">
              <img
                :data-src="imgSrc"
                :alt="imgAlt"
                class="testimonial-image rounded-circle mb-space-xs rds-lazy"
              />
              <h3 class="h3-large mb-space-xxs">{{ name }}</h3>
              <p class="text-dark-1" v-html="designation"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import AOS from "aos";
import "aos/dist/aos.css";

defineProps<{
  quoteText: string;
  imgSrc: string;
  imgAlt: string;
  name: string;
  designation: string;
}>();

onMounted(() => {
  AOS.init({ once: true });
});
</script>

<style scoped>
.quote-container {
  padding: 1.125rem;
  aspect-ratio: 1/1;
  text-align: center;
  font-size: 2rem;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.testimonial-image {
  aspect-ratio: 1 / 1;
  width: 72px;
}
:deep([data-aos="custom-background"]) {
  background-size: 0% 100%;
  transition: background-size 0.5s ease;
}

:deep([data-aos="custom-background"].aos-animate) {
  background-size: 100% 100%;
}
</style>
